import {
  ASSISTANT_SET_OPEN,
  ASSISTANT_LOAD_MESSAGES,
  ASSISTANT_LOAD_MESSAGES_SUCCESS,
  ASSISTANT_LOAD_MESSAGES_FAILURE,
  ASSISTANT_SEND_MESSAGE,
  ASSISTANT_SEND_MESSAGE_SUCCESS,
  ASSISTANT_SEND_MESSAGE_FAILURE,
  ASSISTANT_CLEAR_MESSAGES,
} from './action-types';

const initialState = {
  isOpen: false,
  messages: [],
  conversationId: null,
  pendingNavigation: null,
  isLoading: false,
  isLoadingHistory: false,
  error: null,
};

export default function assistantReducer(state = initialState, action) {
  switch (action.type) {
    case ASSISTANT_SET_OPEN:
      return {
        ...state,
        isOpen: action.payload,
      };

    case ASSISTANT_LOAD_MESSAGES:
      return {
        ...state,
        isLoadingHistory: true,
        error: null,
      };

    case ASSISTANT_LOAD_MESSAGES_SUCCESS:
      return {
        ...state,
        // Local-only turns (file turns) are not on the server; keep them through a reload.
        messages: [
          ...action.payload.messages,
          ...state.messages.filter((msg) => msg.local),
        ],
        conversationId: action.payload.conversationId,
        pendingNavigation: action.payload.pendingNavigation || null,
        isLoadingHistory: false,
        error: null,
      };

    case ASSISTANT_LOAD_MESSAGES_FAILURE:
      return {
        ...state,
        isLoadingHistory: false,
        error: action.payload,
      };

    case ASSISTANT_SEND_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload.userMessage],
        isLoading: true,
        error: null,
      };

    case ASSISTANT_SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: [...state.messages, action.payload.assistantMessage],
        conversationId: action.payload.conversationId || state.conversationId,
        pendingNavigation: null,
        isLoading: false,
        error: null,
      };

    case ASSISTANT_SEND_MESSAGE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case ASSISTANT_CLEAR_MESSAGES:
      return {
        ...state,
        messages: [],
        conversationId: null,
        pendingNavigation: null,
        error: null,
      };

    default:
      return state;
  }
}
